export default {
  'formandbasic-form.basic.title': '基礎表單',
  'formandbasic-form.basic.description':
    '表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。',

  'formandbasic-form.email.required': '請輸入郵箱地址！',
  'formandbasic-form.email.wrong-format': '郵箱地址格式錯誤！',
  'formandbasic-form.userName.required': '請輸入賬戶!',
  'formandbasic-form.password.required': '請輸入密碼！',
  'formandbasic-form.password.twice': '兩次輸入的密碼不匹配!',
  'formandbasic-form.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'formandbasic-form.strength.strong': '強度：強',
  'formandbasic-form.strength.medium': '強度：中',
  'formandbasic-form.strength.short': '強度：太短',
  'formandbasic-form.confirm-password.required': '請確認密碼！',
  'formandbasic-form.phone-number.required': '請輸入手機號！',
  'formandbasic-form.phone-number.wrong-format': '手機號格式錯誤！',
  'formandbasic-form.verification-code.required': '請輸入驗證碼！',
  'formandbasic-form.title.required': '請輸入標題',
  'formandbasic-form.date.required': '請選擇起止日期',
  'formandbasic-form.goal.required': '請輸入目標描述',
  'formandbasic-form.standard.required': '請輸入衡量標淮',

  'formandbasic-form.form.get-captcha': '獲取驗證碼',
  'formandbasic-form.captcha.second': '秒',
  'formandbasic-form.form.optional': '（選填）',
  'formandbasic-form.form.submit': '提交',
  'formandbasic-form.form.save': '保存',
  'formandbasic-form.email.placeholder': '郵箱',
  'formandbasic-form.password.placeholder': '至少6位密碼，區分大小寫',
  'formandbasic-form.confirm-password.placeholder': '確認密碼',
  'formandbasic-form.phone-number.placeholder': '手機號',
  'formandbasic-form.verification-code.placeholder': '驗證碼',
  'formandbasic-form.title.label': '標題',
  'formandbasic-form.title.placeholder': '給目標起個名字',
  'formandbasic-form.date.label': '起止日期',
  'formandbasic-form.placeholder.start': '開始日期',
  'formandbasic-form.placeholder.end': '結束日期',
  'formandbasic-form.goal.label': '目標描述',
  'formandbasic-form.goal.placeholder': '請輸入妳的階段性工作目標',
  'formandbasic-form.standard.label': '衡量標淮',
  'formandbasic-form.standard.placeholder': '請輸入衡量標淮',
  'formandbasic-form.client.label': '客戶',
  'formandbasic-form.label.tooltip': '目標的服務對象',
  'formandbasic-form.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'formandbasic-form.invites.label': '邀評人',
  'formandbasic-form.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'formandbasic-form.weight.label': '權重',
  'formandbasic-form.weight.placeholder': '請輸入',
  'formandbasic-form.public.label': '目標公開',
  'formandbasic-form.label.help': '客戶、邀評人默認被分享',
  'formandbasic-form.radio.public': '公開',
  'formandbasic-form.radio.partially-public': '部分公開',
  'formandbasic-form.radio.private': '不公開',
  'formandbasic-form.publicUsers.placeholder': '公開給',
  'formandbasic-form.option.A': '同事甲',
  'formandbasic-form.option.B': '同事乙',
  'formandbasic-form.option.C': '同事丙',
};
